import { FlexProps } from '@chakra-ui/react';

export interface PageInfo {
  page_number: number;
  page_size: number;
}

export interface PaginationStyles {
  root?: FlexProps;
}

export interface IPagination {
  pageInfo: PageInfo;
  totalCount: number;
  pageSizes?: number[];

  styles?: FlexProps;
  text?: string;

  isLoading?: boolean;

  /** Cursor APIs cannot safely jump to an unvisited last page. */
  cursorBased?: boolean;

  /** totalCount is exact even for cursor APIs: show it instead of "N+". */
  exactTotal?: boolean;

  onChange(info: PageInfo): void;
}

export const DefaultPageSizes = [10, 20, 40, 80, 100];
